import React from 'react';
import { compose } from 'recompose';
import propTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import ViaModal from '../../../../components/library/viaModal';
import Headline from '../../../../components/library/headline';
import Button from '../../../../components/library/button';
import Paragraph from '../../../../components/library/paragraph';
import { getPlan } from '../../../../../actions/plans';
import sSuccessAdminAddedGroupDetail from './successAdminAddedGroupDetail.scss';

export const enhance = compose(withStyles(sSuccessAdminAddedGroupDetail));

function SuccessAdminAddedGroupDetail(props) {
  const dispatch = useDispatch();

  return (
    <>
      <ViaModal
        showing={props.show}
        onClose={() => {
          dispatch(getPlan(props.planId));
          props.onClose(false)
        }}
      >
        <div className={sSuccessAdminAddedGroupDetail['success-admin-added-group-detail']}>
          <div className={sSuccessAdminAddedGroupDetail.subHeader}>
            <Headline centered tag="h1" as="h1">
              Success!
            </Headline>
          </div>
          <div className={sSuccessAdminAddedGroupDetail.subHeader}>
            <Headline centered tag="h1" as="h2">
              THE DETAILS WERE ADDED TO {props.planUsers ? props.planUsers.length : ''} TRAVELERS
            </Headline>
          </div>
          <div className={sSuccessAdminAddedGroupDetail.content}>
            <Paragraph centered size="large">
              These Travelers have been notified that this group detail has been added to their itinerary.
            </Paragraph>
          </div>
          <div className={sSuccessAdminAddedGroupDetail.footer}>
            <div className={sSuccessAdminAddedGroupDetail['footer-button-wrapper']}>
              <div className={sSuccessAdminAddedGroupDetail['button-content']}>
                <Button
                  display="primary"
                  kind="solid"
                  size="medium"
                  onClick={() => {
                    dispatch(getPlan(props.planId));
                    props.onClose(false);
                  }}
                >
                  Return to Who's Going
                </Button>
              </div>
            </div>
          </div>
        </div>
      </ViaModal>
    </>
  )
}

SuccessAdminAddedGroupDetail.propTypes = {
  show: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  planId: propTypes.string.isRequired,
  planUsers: propTypes.array,
};

export default enhance(SuccessAdminAddedGroupDetail);
